import { render } from "./Day.vue?vue&type=template&id=47ba0545&scoped=true"
import script from "./Day.vue?vue&type=script&lang=js"
export * from "./Day.vue?vue&type=script&lang=js"

import "./Day.vue?vue&type=style&index=0&id=47ba0545&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ba0545"]])

export default __exports__